/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 19:01:54
 */

import * as request from '@/utils/request'

export default {
  /**
   * getMixinRechargeList
   * @description 充值流水
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getMxRechargeList(data) {
    return request.post('/mixin/rechargeList', data)
  },
  /**
   * getMixinWithDrawList
   * @description 交易流水
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getMxWithdrawList(data) {
    return request.post('/mixin/withdrawList', data)
  },
}